import React, { useState } from 'react'
import { Button, Col, Popconfirm, Row, Table, Tag } from 'antd'
import { ButtonEx } from '../../../styles/button.style'
import BrandHeroForm from './BrandHeroForm'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../../utils/hooks'
import { fetchBrandHero, saveBrandHero } from '../../../modules/brand'
import PreviewImage from '../../../components/PreviewImage'
import { HeroType } from '../../../config'

const BrandHero = ({ brandId }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)

  const { brandHeroList } = useSelector(
    (state) => ({
      brandHeroList: state.brand.brandHeroList
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandHero(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'No',
      key: 'No',
      render: (text, record, index) => <span>{index + 1}</span>
    },
    {
      title: 'ภาพ',
      dataIndex: 'imageUrl',
      key: 'imageUrl',
      render: (text, record) => (
        <a
          onClick={() => {
            setVisiblePreview(true)
            setPreviewImage(record.imageUrl)
          }}>
          View
        </a>
      )
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email'
    },
    {
      title: 'Hero Type',
      key: 'heroType',
      dataIndex: 'heroType',
      render: (heroType) => <div>{HeroType[heroType].title}</div>
    },
    {
      title: 'Hero Name',
      key: 'name',
      dataIndex: 'name'
    },
    {
      title: 'Tel',
      key: 'tel',
      dataIndex: 'tel'
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (text) =>
        text ? (
          <Tag color="green">Enabled</Tag>
        ) : (
          <Tag color="red">Disabled</Tag>
        )
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onOk(heroId) {
    const arr = []

    for (const item of brandHeroList) {
      arr.push({
        brandId: brandId,
        heroId: item.id,
        enable: true
      })
    }

    arr.push({
      brandId: brandId,
      heroId: heroId,
      enable: true
    })

    const data = {
      brandHeroRequests: arr,
      brandId: brandId
    }

    await dispatch(saveBrandHero(data))
    await dispatch(fetchBrandHero(brandId))
    await setVisible(false)
  }

  const onClick = async (e) => {
    e.preventDefault()
    setVisible(true)
  }

  const onDelete = async (record) => {
    const arr = []

    const results = brandHeroList.filter((item) => item.id !== record.id)
    for (const result of results) {
      arr.push({
        brandId: brandId,
        heroId: result.id,
        enable: true
      })
    }

    const data = {
      brandHeroRequests: arr,
      brandId: brandId
    }

    await dispatch(saveBrandHero(data))
    await dispatch(fetchBrandHero(brandId))
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
  }

  const HeaderTable = () => {
    return (
      <Row type="flex">
        <Col span={12}>
          <span>Hero List</span>
        </Col>
        <Col span={12}>
          <Row type="flex" justify="end">
            <ButtonEx
              color="#6ebf4b"
              type="primary"
              onClick={(e) => onClick(e)}>
              Add Hero
            </ButtonEx>
          </Row>
        </Col>
      </Row>
    )
  }

  return (
    <div>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        title={HeaderTable}
        bordered
        dataSource={brandHeroList}
        columns={columns}
        // pagination={{
        //   current: barcodeProductObj.pageable.pageNumber + 1,
        //   pageSize: barcodeProductObj.size,
        //   pageSizeOptions: ['10', '20', '50', '100'],
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onChange,
        //   total: barcodeProductObj.totalElements
        // }}
      />
      <BrandHeroForm
        formState={formState}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </div>
  )
}

export default BrandHero



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandHero/index.js